import { Auth } from "aws-amplify";
import { API, graphqlOperation, Storage } from "aws-amplify";
import { getAccount, getShop } from "./graphql/queries";
import {
  listAccountsByRol,
  ListShopsByZone,
  OrdersByShops,
  GetShopProfile,
  searchBarAccounts,
  ListShopsByZoneAndCategory,
  ListShopsByZoneAndName,
  ListCategoriesShop,
  getReviewsNotesByID,
  listOffertProducts,
  getCollectsByDelivery,
  GetShopsBetweenDates,
  getReviewsByEvaluatedID,
  getReviewsByEvaluatedIDAndDate,
  OrdersbyShop, OrdersCommissions, 
  getMethodpay,
  getDataBank
} from "../src/graphql/myQueries";
import { createAddress } from "./graphql/mutations";
import { createUserAddress } from "./graphql/mutations";
import {
  updateAccountOne,
  updateAccountPhotoProfile,
  CreateNewAccount
} from "./graphql/myMutations";
import awsconfig from "./aws-exports";
import Location from "aws-sdk/clients/location";

async function createOne(mutation, body) {
  try {
    const response = await API.graphql(graphqlOperation(mutation, body));
    return response;
  } catch (error) {
    console.log(error);
  }
}
// Obtener la información de una cuenta
async function getOne(userId) {
  try {
    const response = await API.graphql({
      query: getAccount,
      variables: { id: userId },
    });
    return response.data.getAccount;
  } catch (error) {
    console.log("error en provider get one",error);
  }
}
// Obtener la información de un negocio
async function getOneShop(shopId) {
  try {
    const credentials = await Auth.currentCredentials();
    const _shop = new Location({
      credentials,
      region: awsconfig.aws_project_region,
    });
    const response = await API.graphql({
      query: GetShopProfile,
      variables: { id: shopId },
    });
    return response.data.getShop;
  } catch (error) {
    console.log(error);
  }
}

// Obtener los comentarios de un negocio por ID (el ID puede ser de un deliveryman o una shop)
async function GetReviewsByEvaluatedID(id) {
  var nextToken = null;
  var reviews = [];
  var response;

  do {
    response = await API.graphql({
      query: getReviewsByEvaluatedID,
      variables: { id: id, nextToken: nextToken },
    });
    nextToken = response["data"]["listReviews"]["nextToken"];
    reviews = reviews.concat(response["data"]["listReviews"]["items"]);
  } while (nextToken != null);
  return reviews;
}

// Listado de comentarios filtrados por fecha de creación
async function GetReviewsByEvaluatedIDAndDate(id, date) {
  var nextToken = null;
  var reviews = [];
  var response;

  do {
    response = await API.graphql({
      query: getReviewsByEvaluatedIDAndDate,
      variables: { id: id, date: date, nextToken: nextToken },
    });
    nextToken = response["data"]["listReviews"]["nextToken"];
    reviews = reviews.concat(response["data"]["listReviews"]["items"]);
  } while (nextToken != null);
  return reviews;
}

async function get(query, variables) {
  try {
    const response = await API.graphql({
      query,
      variables,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

async function getRating(id) {
  let nextToken = null;
  let notes = [];
  let response;

  try {
    do {
      response = await API.graphql({
        query: getReviewsNotesByID,
        variables: { id: id, nextToken: nextToken },
      });
      nextToken = response["data"]["listReviews"]["nextToken"];
      response["data"]["listReviews"]["items"].forEach((note) => {
        notes.push(note["note"]);
      });
    } while (nextToken != null);
    var rating = 0;
    notes.forEach((note) => {
      rating += note;
    });

    return rating / notes.length;
  } catch (error) {
    console.log("error en obtener rating provider", error);
  }
}

// Lista a los empleados de un socio comercial por zona
async function getListEmployees(role, zone) {
  let nextToken = null;
  let items = [];
  try {
    do {
      const response = await API.graphql(
        graphqlOperation(listAccountsByRol, {
          role: role,
          zone: zone,
          nextToken: nextToken,
        })
      );
      nextToken = response["data"]["listAccounts"]["nextToken"];
      items = items.concat(response["data"]["listAccounts"]["items"]);
    } while (nextToken != null);
    return items;
  } catch (error) {
    console.log(error);
  }
}

//Mostrar los productos en oferta de un negocio
async function getListOfferProducts(id_shop) {
  const response = await API.graphql({
    query: listOffertProducts,
    variables: { id: id_shop },
  });
  return response.data.getShop.products;
}

// Lista de tiendas por zona
async function getListShopsByZone(zone) {
  var nextToken = null;
  var shops = [];
  do {
    const response = await API.graphql({
      query: ListShopsByZone,
      variables: { zone_id: zone, nextToken: nextToken },
    });
    nextToken = response["data"]["listShops"]["nextToken"];
    shops = shops.concat(response["data"]["listShops"]["items"]);
  } while (nextToken != null);
  return shops;
}

// Obtener la lista de categorías de negocios
async function GetCategories() {
  var nextToken = null;
  var categories = [];
  var response;

  do {
    response = await API.graphql({
      query: ListCategoriesShop,
      variables: { nextToken: nextToken },
    });
    nextToken = response["data"]["listCategorys"]["nextToken"];
    categories = categories.concat(response["data"]["listCategorys"]["items"]);
  } while (nextToken != null);
  return categories;
}

// Lista de tiendas por zona y categoria
async function listShopsByZoneAndCategory(zone, category) {
  var nextToken = null;
  var shops = [];
  var response;

  do {
    response = await API.graphql({
      query: ListShopsByZoneAndCategory,
      variables: { zone_id: zone, category: category, nextToken: nextToken },
    });
    nextToken = response["data"]["listShops"]["nextToken"];
    shops = shops.concat(response["data"]["listShops"]["items"]);
  } while (nextToken != null);
  return shops;
}

// Obtener lista de negocios por multiples categorías
async function listShopsByMultipleCategories(zone, categories) {
  var shops = [];
  var response;
  for (var i = 0; i < categories.length; i++) {
    response = await listShopsByZoneAndCategory(zone, categories[i]);
    shops[categories[i]] = response;
  }
  return shops;
}

// Lista de tiendas por zona y nombre
async function searchBarShopsByName(zone, name) {
  let nextToken = null;
  let shops = [];
  let response;

  try {
    do {
      response = await API.graphql({
        query: ListShopsByZoneAndName,
        variables: {
          zone_id: zone,
          shop_name: name,
          nextToken: nextToken,
        },
      });
      nextToken = response["data"]["listShops"]["nextToken"];
      shops = shops.concat(response["data"]["listShops"]["items"]);
    } while (nextToken != null);
    return shops;
  } catch (error) {
    console.log(error);
  }
}

// Filtrar trabajadores por zona, rol y nombre para la barra de busqueda
async function searchBar(role, zone, name) {
  var nextToken = null;
  var items = [];
  try {
    do {
      const response = await API.graphql(
        graphqlOperation(searchBarAccounts, {
          name: name,
          role: role,
          zone: zone,
          nextToken: nextToken,
        })
      );
      nextToken = response["data"]["listAccounts"]["nextToken"];
      items = items.concat(response["data"]["listAccounts"]["items"]);
    } while (nextToken != null);
    return items;
  } catch (error) {
    console.log(error);
  }
}

// Registrar a un usuario
export async function SignUpService({email, password, name, lastName, birthDate, sex, phone, role, zone, state, zipCode, city, street, outdoorNumber, photo,}) {

  //SignUp with Amplify
  const user = await Auth.signUp({
    username: email,
    password: password,
    attributes: {
      email,
      given_name: name,
      family_name: lastName,
      birthdate: birthDate, //AWSDate -> ISO 8601 date string in the format YYYY-MM-DD.
      phone_number: "+52" + phone,
    },
    clientMetadata: {
      groupName: role,
    },
  });
  
  // Upload photo
  let fileName = "";
  if (photo) {
    try {
      fileName = "imageProfile-" + user.userSub + "." + photo.name.split(".")[1];
      // Upload to S3 bucket
      const response = await Storage.put(fileName, photo, {
        contentType: photo.type,
      });
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  }
 
  const myDate = new Date(birthDate).toISOString();
  const userdb = await createOne(CreateNewAccount, {
    input: {
      id: user.userSub,
      email,
      last_name: lastName,
      name,
      sexo: sex,
      role,
      zone,
      birthday: myDate,
      phone_number: phone,
      url_photoProfile: fileName,
    },
  });

  const usera = await createOne(createAddress, {
    input: {
      country: state, 
      postal_code: zipCode,
      street, 
      city: city,
      id: `${user.userSub}Address`,
      outdoor_number: outdoorNumber,
    },
  });

  const usercon = await createOne(createUserAddress, {
    input: {
      active: true,
      userAddressAddress_idId: `${user.userSub}Address`,
      userAddressUser_idId: user.userSub,
    },
  });

  return {id: user.userSub, temporaryPass: password};
}

async function ConfirmSignup({id, code, data}) {
  const { role, zone, birthDate } = data;
  const date = new Date(birthDate).toISOString();
  try {
    const username = id; 
    const response = await Auth.confirmSignUp(username, code);
    await API.graphql(graphqlOperation(updateAccountOne, {
      input:{
        id,
        role,
        birthday: date,
        zone,
      }
    }));
    return response;
  } catch (error) {
    throw new Error(error);
  }
} 

// "borrar" a un trabajador
async function updateOne({ id, zone }) {
  const result = await API.graphql(
    graphqlOperation(updateAccountOne, {
      input: {
        id,
        zone,
      },
    })
  );
  return result;
}

async function geoLocationShop(id_shop) {
  let _shop = null;
  let adress = null;
  let latitud = null;
  let longitud = null;

  //Crear Usuario que permite el acceso al servicio de Locación de AWS
  const credentials = await Auth.currentCredentials();
  _shop = new Location({
    credentials,
    region: awsconfig.aws_project_region,
  });

  //Query para obtener la información de un negocio
  const response = await API.graphql({
    query: GetShopProfile,
    variables: { id: id_shop },
  });
  adress = response["data"]["getShop"]["address_shop"];

  //Valores para buscar la dirección y obtener los puntos
  const params = {
    IndexName: "NikuPlaceIndex", //Nombre del servicio de AWS
    Text: adress, //Dirección del negocio
  };

  return new Promise((resolve) => {
    _shop.searchPlaceIndexForText(params, (err, data) => {
      if (err) console.log("error en search place", err);
      if (data) {
        [latitud, longitud] =
          data["Results"]["0"]["Place"]["Geometry"]["Point"];
        resolve({ lat: longitud, lng: latitud });
      }
    });
  });
}

async function getCollectsBetweenDates({ id, startDate, endDate }) {
  let numberOfCollects = 0;
  const response = await API.graphql({
    query: getCollectsByDelivery,
    variables: { id: id, betweenDates: [startDate, endDate] },
  });
  numberOfCollects =
    response["data"]["getAccount"]["deliveryman_collects"]["items"].length;
  return numberOfCollects;
}

async function getShopsBetweenDates({ id, startDate, endDate }) {
  let nextToken = null;
  let numberOfShops = 0;
  let response;
  do {
    response = await API.graphql({
      query: GetShopsBetweenDates,
      variables: {
        affiliator_id: id,
        betweenDates: [startDate, endDate],
        nextToken: nextToken,
      },
    });
    numberOfShops += response["data"]["listShops"]["items"].length;
    nextToken = response["data"]["listShops"]["nextToken"];
  } while (nextToken != null);
  return numberOfShops;
}

async function consumeS3Image(url_photoProfile) {
  const my = await Storage.get(url_photoProfile)
    .then((result) => {
      return result;
    })
    .catch((err) => console.log(err));
  return my;
}

//Obtener las comisiones de todos los negocios de la zona
async function generalCommissions(zone){
  var arrayforshops = [];
  var orders = [];
  var idShop;
  var idNameShop;

  const result = await API.graphql(graphqlOperation(OrdersByShops, { zone: zone }));
  arrayforshops = result.data.listShops.items;

  if(arrayforshops.length > 0){
    for (var i in arrayforshops){
      idShop =  arrayforshops[i].id; //id de la tienda
      idNameShop =  arrayforshops[i].shop_name; //nombre de la tienda
      orders = arrayforshops[i].orders.items;
      if(orders.length > 0){
        var sumtotal = 0; //Total de las ordenes
        for (var a in orders){
          sumtotal = sumtotal + orders[a].final_total;
        }
        var totalSumaTienda = parseFloat(sumtotal.toFixed(2)); 
        arrayforshops[i]["commissionTotal"] = totalSumaTienda;
      }else{
        arrayforshops[i]["commissionTotal"] = parseFloat(0);
      }
    }
    return arrayforshops;
  } 
}

//Comisión de una tienda en especifica
async function ordersByShop(idShop){
  let arrayforallorders = [];

  const result = await API.graphql(graphqlOperation(OrdersbyShop, { id: idShop }));
  arrayforallorders = result.data.getShop.orders.items;
  if (arrayforallorders.length > 0){
    var sumtotal = 0; //Total de las ordenes
    for (var i in arrayforallorders){
      sumtotal = sumtotal + arrayforallorders[i].final_total;
    }
    let totalSumaTienda = parseFloat(sumtotal.toFixed(2)); 
  }
  return arrayforallorders;
}

//Ordenes por tienda
async function GetOrdersCommissions(id) {
  var nextToken = null;
  var orders = [];

  do {
    const response = await API.graphql({ query: OrdersCommissions , variables: { id: id }});
    nextToken = response['data']['getShop']['orders']['nextToken'];
    orders = orders.concat(response['data']['getShop']/* ['orders']['items'] */);
  } while (nextToken != null);
  return orders;
}
async function GetMthodPayServ(id){
  const res =  await API.graphql({ query: getMethodpay , variables: { id: id }});
  return res;
}
 
async function GetDataBankShopService(id){
  const res =  await API.graphql({ query: getDataBank , variables: { id: id }});
  return res;
}


async function uploadPhoto(resource, id, body) {}

async function deleteOne(resource, id) {}

async function subscribe(subscription, variables) {
  try {
    const response = await API.graphql(
      graphqlOperation(subscription, variables)
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
}
export {
  consumeS3Image,
  createOne,
  ConfirmSignup,
  geoLocationShop,
  get,
  getCollectsBetweenDates,
  getOne,
  getRating,
  getOneShop,
  GetReviewsByEvaluatedID,
  getListEmployees,
  getListShopsByZone,
  GetCategories,
  getShopsBetweenDates,
  getListOfferProducts,
  listShopsByZoneAndCategory,
  GetReviewsByEvaluatedIDAndDate,
  listShopsByMultipleCategories,
  generalCommissions,
  searchBarShopsByName,
  GetOrdersCommissions,
  ordersByShop,
  searchBar,
  updateOne,
  uploadPhoto,
  deleteOne,
  subscribe,
  GetMthodPayServ,
  GetDataBankShopService
};